import { StyledSvg } from "baseui/icon";
import { omit } from "lodash";
import React from "react";

export const SparkleIcon = (props: React.ComponentProps<typeof StyledSvg> & { white?: boolean }) => {
  // In docs, we use the same icon in both the desktop and mobile views.
  // So we need to generate a random id for the gradient to make sure the id is unique. Otherwise, the gradient will not be shown and it will look like the icon is missing.
  const randomId = Math.random().toString(36).substring(2, 15);

  if (props.white) {
    return (
      <svg {...omit(props, "gradient")} height={16} width={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d={pathDAttribute} fill="white" />
      </svg>
    );
  }

  return (
    <StyledSvg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d={pathDAttribute} fill="url(#paint0_radial_2231_9971)" />
      <defs>
        <radialGradient
          id="paint0_radial_2231_9971"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.60523 11.5715) rotate(46.3593) scale(15.0617 14.638)"
        >
          <stop offset="0.015" stopColor="#A259FF" />
          <stop offset="1" stopColor="#FF597D" />
        </radialGradient>
      </defs>
    </StyledSvg>
  );
};

const pathDAttribute =
  "M9.83716 4.62808C10.0977 3.57469 11.5967 3.57467 11.8572 4.62808L12.2908 6.38883C12.9389 9.01279 14.9885 11.0626 17.6126 11.7106L19.3733 12.1457C20.4272 12.406 20.4273 13.904 19.3733 14.1642L17.6126 14.5993C14.9883 15.2474 12.9387 17.2967 12.2908 19.9211L11.8572 21.6818C11.5964 22.7346 10.098 22.7347 9.83716 21.6818L9.40357 19.9211C8.75568 17.2967 6.70603 15.2474 4.08179 14.5993L2.32105 14.1642C1.26703 13.904 1.2672 12.4061 2.32105 12.1457L4.08179 11.7106C6.70573 11.0625 8.75542 9.01274 9.40357 6.38883L9.83716 4.62808ZM18.635 1.78482C18.719 1.44676 19.2001 1.44669 19.2839 1.78482C19.6411 3.23019 20.7696 4.36052 22.2151 4.71744C22.5536 4.8012 22.5538 5.28276 22.2151 5.36637C20.7696 5.72347 19.6409 6.85194 19.2839 8.29752C19.1997 8.63502 18.7192 8.63503 18.635 8.29752C18.2781 6.85173 17.1482 5.72335 15.7024 5.36637C15.3645 5.28248 15.3648 4.80168 15.7024 4.71744C17.148 4.36059 18.2778 3.23027 18.635 1.78482Z";
